var _path, _path2, _rect, _path3, _path4, _path5, _path6, _rect2, _path7, _rect3, _rect4, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12Culture(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2024 0.307862C19.3741 0.18146 19.5818 0.113281 19.7951 0.113281H21.1378C21.3514 0.113281 21.5594 0.18166 21.7313 0.308404L40.0602 13.8225C40.3159 14.011 40.4668 14.3097 40.4668 14.6274V15.1133C40.4668 15.6656 40.0191 16.1133 39.4668 16.1133H1.4668C0.914511 16.1133 0.466797 15.6656 0.466797 15.1133V14.601C0.466797 14.283 0.618003 13.984 0.874092 13.7956L19.2024 0.307862Z",
    fill: "#E7E6F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6494 0.25L40.4672 14.1454V16.1365H28.4672V14.1185L21.6494 0.25Z",
    fill: "#ABA9C8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.4668,
    y: 16.1133,
    width: 36,
    height: 2,
    rx: 1,
    fill: "#E7E6F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4668 16.1133H38.4668V17.1133H2.4668V16.1133Z",
    fill: "#ABA9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4668 35.1133C2.4668 34.561 2.91451 34.1133 3.4668 34.1133H37.4668C38.0191 34.1133 38.4668 34.561 38.4668 35.1133V36.1133H2.4668V35.1133Z",
    fill: "#4841A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4668 34.1133H37.4668C38.0191 34.1133 38.4668 34.561 38.4668 35.1133V36.1133H28.4668L12.4668 34.1133Z",
    fill: "#353071"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.466797 37.1133C0.466797 36.561 0.914512 36.1133 1.4668 36.1133H39.4668C40.0191 36.1133 40.4668 36.561 40.4668 37.1133V39.1133C40.4668 39.6656 40.0191 40.1133 39.4668 40.1133H1.4668C0.914511 40.1133 0.466797 39.6656 0.466797 39.1133V37.1133Z",
    fill: "#E7E6F0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.4668,
    y: 18.1133,
    width: 8,
    height: 16,
    fill: "#E7E6F0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4668 18.1133H12.4668V29.1133L4.4668 22.1133V18.1133Z",
    fill: "#ABA9C8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.4668,
    y: 18.1133,
    width: 8,
    height: 16,
    fill: "#E7E6F0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4668,
    y: 18.1133,
    width: 8,
    height: 16,
    fill: "#E7E6F0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4668 18.1133H24.4668V29.1133L16.4668 22.1133V18.1133Z",
    fill: "#ABA9C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4668 18.1133H36.4668V29.1133L28.4668 22.1133V18.1133Z",
    fill: "#ABA9C8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12Culture);
export default __webpack_public_path__ + "static/media/12_culture.631cb4d8ebe8ff49ff9b9c5613ec2b3b.svg";
export { ForwardRef as ReactComponent };